<script setup></script>

<template>
	<nuxt-layout>
		<div class="error-page__container">
			<div class="error-page__image-block">
				<nuxt-img src="/images/404.png" height="286" width="216" class="error-page__image" />
			</div>
			<div class="error-page__content-block">
				<h1 class="error-page__title">Страница не найдена</h1>
				<div class="error-page__message">
					Страница, на которую вы пытаетесь перейти не найдена. Возможно, вы ввели неправильный
					адрес, или страница была удаленна.
				</div>
				<nuxt-link to="/" class="error-page__link">
					<div class="error-page__link-text">Вернуться на главную</div>
					<Icon name="local:arrow-up-right" class="error-page__link-icon" aria-hidden="true" />
				</nuxt-link>
			</div>
		</div>
	</nuxt-layout>
</template>

<style lang="scss" scoped>
	.error-page__container {
		margin: 40px 0px;
		display: flex;
		gap: 15px;
		max-width: 1240px;
		height: 100%;
		padding-left: var(--layout-padding);
		padding-right: var(--layout-padding);
	}
	.error-page__image-block {
		flex: 0 0 108px;
		height: 143px;
		width: 108px;
	}
	.error-page__image {
		height: 100%;
		width: 100%;
	}

	.error-page__title {
		font-size: var(--font-size-title);
		margin-bottom: 24px;
	}
	.error-page__message {
		margin-bottom: 24px;
	}
	.error-page__link {
		display: flex;
		align-items: center;
		gap: 12px;
		width: fit-content;
		&:hover {
			color: var(--color-secondary-dark);
		}
	}
	.error-page__link-icon {
		transform: rotate(45deg);
		width: 20px;
		height: 20px;
	}

	@media (min-width: 1240px) {
		.error-page__container {
			margin: 50px 100px;
			gap: 30px;
		}
		.error-page__image-block {
			flex: 0 0 216px;
			height: 286px;
			width: 216px;
		}

		.error-page__title {
			margin-bottom: 39px;
		}
		.error-page__message {
			line-height: 34px;
			color: var(--color-ucla-blue);
			margin-bottom: 35px;
		}
		.error-page__link-icon {
			transform: rotate(45deg);
			width: 24px;
			height: 24px;
		}
	}
</style>
